"use client";

import { Slot } from "@radix-ui/react-slot";
import { motion, useInView } from "motion/react";
import { useRef } from "react";

/**
 * AnimateMedia
 */
type AnimateMediaProps = {
  children: React.ReactNode;
  direction?: "left" | "right";
};

export function AnimateMedia({ direction = "left", ...props }: AnimateMediaProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.7 });

  const directionRatio = direction === "left" ? -1 : 1;

  const variants = {
    initial: { opacity: 0, x: 50 * directionRatio },
    animate: { opacity: 1, x: 0 },
  };

  const Comp = motion.create(Slot);

  return (
    <Comp
      {...props}
      ref={ref}
      initial="initial"
      animate={isInView ? "animate" : "initial"}
      transition={{ duration: 0.5, ease: "easeOut" }}
      variants={variants}
    />
  );
}
